import { createSlice } from "@reduxjs/toolkit";
import {
  GetAllReportProblemAction,
  UpdateReportAction,
} from "store/middlewares/reportProblem";

export const reportProblemSlice = createSlice({
  name: "reportProblem",
  initialState: {
    reportProblemLoading: true,
    reportProblem: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(GetAllReportProblemAction.pending, (state) => {
        // state.reportProblemLoading = true;
        // state.reportProblem = null;
        state.reportProblem =
          state.reportProblem?.data?.length > 0
            ? state.reportProblem
            : null;
      })
      .addCase(GetAllReportProblemAction.fulfilled, (state, action) => {
        state.reportProblemLoading = false;
        state.reportProblem = action.payload.response;
      })
      .addCase(GetAllReportProblemAction.rejected, (state) => {
        state.reportProblemLoading = false;
        state.reportProblem = null;
      })

      // .addCase(UpdateReportAction.fulfilled, (state, action) => {
      //   state.reportProblemLoading = false;
      //   state.reportProblem = action.payload.response;
      // });

      // update
      .addCase(UpdateReportAction.fulfilled, (state, action) => {
        // state.reportProblemLoading = false;
        // state.reportProblem = {
        //   ...state.reportProblem,
        //   // total: Number(state.reportProblem.total) - 1,
        //   data: state.reportProblem?.data?.filter(
        //     (item) => item.id !== action.payload.response.id
        //   ),
        // };
        state.reportProblemLoading = false;
        state.reportProblem = action.payload.response;
      });
  },
});
export default reportProblemSlice.reducer;
